import ReactGA from "react-ga4";
import RED_API from '../network/redAPI'

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA;

// start GA
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

//tracking all pge views
export const logPageView = (path) => {
  ReactGA.send("screen_view", { page: path });
};

// tracking purchase
export const logPurchase = async (items, payment_data) => {
  if(!items || !payment_data){
    return;
  }
  let orderData = [];
  const user = localStorage.getItem("user");
  const orderId = localStorage.getItem("order_id");
  try{
    await RED_API.FetchParticularOrder({ order_id: parseInt(orderId), lang:'en' })
        .then((res) => res.json())
        .then(res => {
          if (res.success) {
            orderData = res.data
          }
    });
  }catch(e){
    console.log(e)
  };

  ReactGA.event("purchase", {
	  payment_id: orderData.order_payment_details[0]?.payment_id,
    order_id: orderId,
    user_id: JSON.parse(user).cust_id,
    user_name: JSON.parse(user).name,
	  item_total: orderData?.item_total,
	  value: orderData?.amount,
	  delivery_fees: orderData?.delivery_fees,
    currency: "USD",
    order_type: orderData.type === 0 ? "normal" : "express",
	  wallet_discount_amount: orderData?.wallet_payment,
	  coupon: orderData?.coupon_code_id,
    address: payment_data[0].address_used.city,
    items: items.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      price: item.item_price,
      currency: "USD",
      quantity: item.quantity,
    })),
  });
};

// tracking shipping info
export const logShippingInfo = async (items, address) => {
  if(!items || !address){
    return;
  }
  let orderData = [];
  const user = localStorage.getItem("user");
  const orderId = localStorage.getItem("order_id");
  try{
    await RED_API.FetchParticularOrder({ order_id: parseInt(orderId), lang:'en' })
        .then((res) => res.json())
        .then(res => {
          if (res.success) {
            orderData = res.data
          }
    });
  }catch(e){
    console.log(e)
  }
  ReactGA.event("add_shipping_info", {
    order_id: orderId,
    user_id: JSON.parse(user).cust_id,
    user_name: JSON.parse(user).name,
	  item_total: orderData?.item_total,
	  value: orderData.order_payment_details[0]?.amount,
	  delivery_fees: orderData?.delivery_fees,
    currency: "USD",
    order_type: orderData.type === 0 ? "normal" : "express",
	  wallet_discount_amount: orderData?.wallet_payment,
	  coupon: orderData?.coupon_code_id,
    address: address?.city,
    location_id:address.address_id,
    recipient_name: address?.cust_id,
    shipping_address:address?.area_details,
    items: items.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      price: item.item_price,
      currency: "USD",
      quantity: item.quantity,
    })),
  });
};

// tracking shipping info
export const logPaymentInfo = async (items, payment_data) => {
  if(!items || !payment_data){
    return;
  }
  let orderData = [];
  const user = localStorage.getItem("user");
  const orderId = localStorage.getItem("order_id");
  try{
    await RED_API.FetchParticularOrder({ order_id: parseInt(orderId), lang:'en' })
        .then((res) => res.json())
        .then(res => {
          if (res.success) {
            orderData = res.data
          }
    });
  }catch(e){
    console.log(e)
  }
  ReactGA.event("add_payment_info", {
    order_id: orderId,
    user_id: JSON.parse(user).cust_id,
    user_name: JSON.parse(user).name,
	  item_total: orderData?.item_total,
	  value: orderData?.amount,
	  delivery_fees: orderData?.delivery_fees,
    currency: "USD",
    order_type: orderData.type === 0 ? "normal" : "express",
	  wallet_discount_amount: orderData?.wallet_payment,
	  coupon: orderData?.coupon_code_id,
    payment_type:payment_data,
    items: items.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      price: item.item_price,
      currency: "USD",
      quantity: item.quantity,
    })),
  });
};

// tracking purchase
export const logPurchaseOnOnlinePayment = async (data) => {
  const newData = JSON.parse(data)
  if(!newData){
    return;
  }
  let orderData = [];
  const user = localStorage.getItem("user");
  try{
    await RED_API.FetchParticularOrder({ order_id: parseInt(newData?.item[0].order_id), lang:'en' })
        .then((res) => res.json())
        .then(res => {
          if (res.success) {
            orderData = res.data
          }
    });
  }catch(e){
    console.log(e)
  };

  ReactGA.event("purchase", {
	  payment_id: orderData.order_payment_details[0]?.payment_id,
    order_id: newData.item[0].order_id,
    user_id: JSON.parse(user).cust_id,
    user_name: JSON.parse(user).name,
	  item_total: orderData?.item_total,
	  value: orderData.order_payment_details[0]?.amount,
	  delivery_fees: orderData?.delivery_fees,
    currency: "USD",
    order_type: orderData.type === 0 ? "normal" : "express",
	  wallet_discount_amount: orderData?.wallet_payment,
	  coupon: orderData?.coupon_code_id,
    address: newData.data[0].address_used.city,
    items: newData.item.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      price: item.item_price,
      currency: "USD",
      quantity: item.quantity,
    })),
  });
};

// tracking checkout
export const logCheckout = (data) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};
		const orderId = localStorage.getItem("order_id");

		if (!data || !data.items || !Array.isArray(data.items)) {
			console.error("Invalid checkout data:", data);
			return;
		}

		ReactGA.event("begin_checkout", {
			currency: "USD",
			order_id: orderId,
			value: data.carttotal ?? 0,
			coupon: data.coupon,
			user_id: userData.cust_id,
			user_name: userData.name,
			items: data.items.map((item) => ({
				item_id: item.item_id,
				item_name: item.item_name ?? item.name ?? 'Unknown Item',
				price: item.item_price ?? item.price ?? 0,
				currency: "USD",
				quantity: item.quantity ?? 1,
			})),
		});
	} catch (e) {
		console.error("Error logging begin_checkout event:", e);
	}
};

export const logAddToCart = (order, type = 0) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		// Safely extract item data
		const itemId = order.CurrentItemInfo?.store_items_price_type?.item_id ?? order.item_id;
		const itemName = order.CurrentItemInfo?.name ?? order.name ?? 'Unknown Item';
		const itemPrice = order.CurrentItemInfo?.store_items_price_type?.price ?? order.price ?? 0;
		const itemBrand = order.brandInfo?.name ?? order.brand?.name;
		const itemCategory = order.categoryInfo?.name ?? order.category?.name;

		ReactGA.event("add_to_cart", {
			currency: "USD",
			order_id: order.order_id,
			item_id: itemId,
			item_name: itemName,
			value: itemPrice,
			user_id: userData.cust_id,
			user_name: userData.name,
			items: [{
				item_id: itemId,
				item_name: itemName,
				item_brand: itemBrand,
				item_category: itemCategory,
				price: itemPrice,
				currency: "USD",
				quantity: 1,
			}],
		});
	} catch (e) {
		console.error("Error logging add_to_cart event:", e);
	}
};

export const logRemoveFromCart = (order, type = 0) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};
		const orderId = localStorage.getItem("order_id");

		let itemId, itemName, itemPrice, itemBrand, itemCategory, currentOrderId;

		if (type === 3) {
			// Type 3: Direct item data
			currentOrderId = orderId;
			itemId = order.item_id;
			itemName = order.name ?? 'Unknown Item';
			itemPrice = order?.store_items_price_types?.[0]?.price ?? order.price ?? 0;
			itemBrand = order.brand?.name ?? order.brandInfo?.name;
			itemCategory = order.category?.name ?? order.categoryInfo?.name;
		} else if (type === 0) {
			// Type 0: CurrentItemInfo structure
			currentOrderId = order.order_id ?? orderId;
			itemId = order.CurrentItemInfo?.store_items_price_type?.item_id ?? order.item_id;
			itemName = order.CurrentItemInfo?.name ?? order.name ?? 'Unknown Item';
			itemPrice = order.CurrentItemInfo?.store_items_price_type?.price ?? order.price ?? 0;
			itemBrand = order.brandInfo?.name ?? order.brand?.name;
			itemCategory = order.categoryInfo?.name ?? order.category?.name;
		} else {
			// Type 1: List structure
			currentOrderId = orderId;
			itemId = order.item_id;
			itemName = order.item_name ?? order.name ?? 'Unknown Item';
			itemPrice = order?.store_items_price_types?.[0]?.price ?? order.price ?? 0;
			itemBrand = order.list_brands?.[0]?.brand_id ?? order.brandId;
			itemCategory = order.list_categories?.[0]?.cat_id ?? order.catId ?? order.cat_id;
		}

		const payload = {
			currency: "USD",
			order_id: currentOrderId,
			item_id: itemId,
			item_name: itemName,
			value: itemPrice,
			user_id: userData.cust_id,
			user_name: userData.name,
			items: [{
				item_id: itemId,
				item_name: itemName,
				item_brand: itemBrand,
				item_category: itemCategory,
				price: itemPrice,
				currency: "USD",
				quantity: 1,
			}],
		};

		ReactGA.event("remove_from_cart", payload);
	} catch (e) {
		console.error("Error logging remove_from_cart event:", e);
	}
};

// tracking clear cart event
export const logClearCart = () => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		ReactGA.event("clear_cart", {
			label: "Clear Cart",
			cust_id: userData.cust_id,
			user_id: userData.cust_id,
			user_name: userData.name,
		});
	} catch (e) {
		console.error("Error logging clear_cart event:", e);
	}
};

// tracking click view item event
export const logViewItem = (item, location) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		// Safely extract price from different possible locations
		const itemPrice = item.price
			?? item?.store_items_price_types?.[0]?.price
			?? item?.store_items_price_type?.price
			?? 0;

		// Safely extract brand
		const itemBrand = item.list_brands?.[0]?.brand_id
			?? item.list_brand?.brand_id
			?? item.brandId;

		// Safely extract category
		const itemCategory = item.list_categories?.[0]?.cat_id
			?? item.list_category?.cat_id
			?? item.catId
			?? item.cat_id;

		const eventPayload = {
			currency: "USD",
			item_id: item.item_id,
			item_name: item.item_name || item.name,
			value: itemPrice,
			user_id: userData.cust_id,
			user_name: userData.name,
			page_location: location,
			items: [{
				item_id: item.item_id,
				item_name: item.item_name || item.name,
				item_brand: itemBrand,
				item_category: itemCategory,
				currency: "USD",
				price: itemPrice,
			}],
		};

		ReactGA.event("view_item", eventPayload);
	} catch (e) {
		console.error("Error logging view_item event:", e);
	}
};

// tracking search item event
export const logSearchQuery = (searchTerm) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		ReactGA.event("search_query", {
			search_query: searchTerm ?? '',
			user_id: userData.cust_id,
			user_name: userData.name,
		});
	} catch (e) {
		console.error("Error logging search_query event:", e);
	}
};

// tracking add to wishlist
export const logAddToWishlist = (item) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		// Safely extract item data
		const itemId = item.item_id ?? item.id ?? item.itemId;
		const itemName = item.item_name ?? item.name ?? 'Unknown Item';
		const itemPrice = item.price
			?? item?.store_items_price_types?.[0]?.price
			?? item?.store_items_price_type?.price
			?? 0;
		const itemBrand = item.list_brands?.[0]?.brand_id
			?? item.list_brand?.brand_id
			?? item.brandId
			?? item.brand_id;
		const itemCategory = item.list_categories?.[0]?.cat_id
			?? item.list_category?.cat_id
			?? item.catId
			?? item.cat_id;

		ReactGA.event("add_to_wishlist", {
			currency: "USD",
			item_id: itemId,
			item_name: itemName,
			value: itemPrice,
			user_id: userData.cust_id,
			user_name: userData.name,
			items: [{
				item_id: itemId,
				item_name: itemName,
				item_brand: itemBrand,
				item_category: itemCategory,
				currency: "USD",
				price: itemPrice,
			}],
		});
	} catch (e) {
		console.error("Error logging add_to_wishlist event:", e);
	}
};

// tracking remove wishlist
export const logRemoveFromWishlist = (item) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		// Safely extract item data
		const itemId = item.item_id ?? item.id ?? item.itemId;
		const itemName = item.item_name ?? item.name ?? 'Unknown Item';
		const itemPrice = item.price
			?? item?.store_items_price_types?.[0]?.price
			?? item?.store_items_price_type?.price
			?? 0;
		const itemBrand = item.list_brands?.[0]?.brand_id
			?? item.list_brand?.brand_id
			?? item.brandId
			?? item.brand_id;
		const itemCategory = item.list_categories?.[0]?.cat_id
			?? item.list_category?.cat_id
			?? item.catId
			?? item.cat_id;

		ReactGA.event("remove_from_wishlist", {
			currency: "USD",
			item_id: itemId,
			item_name: itemName,
			value: itemPrice,
			user_id: userData.cust_id,
			user_name: userData.name,
			items: [{
				item_id: itemId,
				item_name: itemName,
				item_brand: itemBrand,
				item_category: itemCategory,
				currency: "USD",
				price: itemPrice,
			}],
		});
	} catch (e) {
		console.error("Error logging remove_from_wishlist event:", e);
	}
};

// tracking clear wishlist
export const logClearWishlist = (cust_id) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		ReactGA.event("clear_wishlist", {
			cust_id: cust_id ?? userData.cust_id,
			user_id: cust_id ?? userData.cust_id,
			user_name: userData.name,
		});
	} catch (e) {
		console.error("Error logging clear_wishlist event:", e);
	}
};
//tracking all pge views
export const logEventView = (pageType,page_id,total,list=null) => {
  const user = localStorage.getItem("user");
  if(user){
    ReactGA.event("page_view", { 
      page_type:pageType,
      user_id: JSON.parse(user)?.cust_id,
      page_id:page_id,
      total_items: total,
      product_list: list,
    });
  }else{
    ReactGA.event("page_view", { 
      page_type: pageType,
      user_id: undefined,
      page_id:page_id,
      total_items: total,
      product_list: list,
    });
  }
};

export const logSeenEventView = (pageType, product, related_products = null, cross_sale_products = null) => {
	try {
		const user = localStorage.getItem("user");
		const userData = user ? JSON.parse(user) : {};

		// Handle both item_id only (backward compatibility) and full product object
		let itemId;

		if (typeof product === 'object' && product !== null) {
			itemId = product.item_id ?? product.id;
		} else {
			itemId = product;
		}

		const eventPayload = {
      page_type: pageType,
			user_id: userData.cust_id,
			item_id: itemId,
			related_products: related_products,
			cross_sale_products: cross_sale_products,
		};

		ReactGA.event("view_item", eventPayload);
	} catch (e) {
		console.error("Error logging view_item event (product detail):", e);
  }
};

export const logEventPromotionClick = (id) => {
  ReactGA.event("promotion", {
    campaign_id: id,
  });
};


export const logEventLogin = (id,trigger) => {
  ReactGA.event("login", {
    user_id: id,
    trigger:trigger
  });
};


export const logEventRegistration = (id,trigger) => {
  ReactGA.event("sign_up", {
    user_id: id,
    trigger:trigger
  });
};
